import { render } from "./FormSchedule.vue?vue&type=template&id=23f95a54&scoped=true"
import script from "./FormSchedule.vue?vue&type=script&lang=js"
export * from "./FormSchedule.vue?vue&type=script&lang=js"

import "./FormSchedule.vue?vue&type=style&index=0&id=23f95a54&lang=less&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f95a54"]])

export default __exports__